import React, { useState, useEffect } from 'react';
import api from '../services/api';
import AddLietSiQuanHe from './AddLietSiQuanHe'; 

function AddThanNhanModalTinhAdmin({ onClose, onSave }) {
  const [formData, setFormData] = useState({
    ho_ten: '',
    nam_sinh: '', // (*** SỬA ***)
    cccd: '', 
    dia_chi: '',
    xa_id: '' 
  });
  
  const [moiQuanHeList, setMoiQuanHeList] = useState([]); 
  const [xaPhuongList, setXaPhuongList] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');
  
  const clearError = () => setError(''); 

  // (*** SỬA ***)
  const { ho_ten, nam_sinh, cccd, dia_chi, xa_id } = formData;
  
  // Tải danh sách xã (giữ nguyên)
  useEffect(() => {
    const fetchXaPhuong = async () => {
      try {
        const res = await api.get('/data/xaphuong');
        setXaPhuongList(res.data);
        if (res.data.length > 0 && !xa_id) {
            setFormData(prev => ({ ...prev, xa_id: String(res.data[0].id) }));
        }
      } catch (err) {
        console.error("Lỗi tải danh sách xã:", err);
        setError('Không thể tải danh sách xã.');
      }
    };
    fetchXaPhuong();
  }, []);

  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  // (*** SỬA ***) Cập nhật validation và API
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // (*** SỬA ***) Thêm validation cho nam_sinh
    if (!ho_ten || !nam_sinh || !cccd || !dia_chi || !xa_id) { 
        setError('Họ tên, Năm sinh, CCCD, Địa chỉ và Xã là bắt buộc.'); 
        return; 
    }
    if (!/^\d{4}$/.test(nam_sinh)) {
        setError('Năm sinh phải là 4 chữ số (ví dụ: 1950).');
        return;
    }
    
    if (cccd.length < 3) { setError('CCCD phải có ít nhất 3 ký tự.'); return; }
    
    if (moiQuanHeList.length === 0) {
        setError('Bắt buộc phải thêm ít nhất một Liệt sĩ liên quan.');
        return;
    }

    setIsSaving(true);
    try {
      // (*** SỬA ***) Gửi 'nam_sinh' lên API
      const res = await api.post('/than-nhan/tinh-admin-add', {
        ho_ten,
        nam_sinh: nam_sinh,
        cccd, 
        dia_chi,
        xa_id: Number(xa_id),
        moiQuanHeList 
      });
      
      onSave(res.data); 
      onClose();

    } catch (err) {
      setError(err.response?.data?.message || 'Lỗi khi thêm mới');
      setIsSaving(false);
    }
  };

  // (CSS giữ nguyên)
  const modalStyles = {
    overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center' },
    content: { background: 'white', padding: '20px', borderRadius: '8px', width: '90%', maxWidth: '800px', maxHeight: '90vh', overflowY: 'auto' }, 
    h3: { marginTop: '0' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' },
    inputGroup: { display: 'flex', flexDirection: 'column' },
    button: { background: '#007bff', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '4px', cursor: 'pointer', marginRight: '10px' },
    closeButton: { background: '#ccc', color: 'black' },
    error: { color: 'red', fontWeight: 'bold' }
  };


  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.content} onClick={e => e.stopPropagation()}>
        <h3 style={modalStyles.h3}>Thêm mới Thân nhân (Tỉnh/Admin)</h3>
        <p style={{color: 'purple'}}>Thân nhân được thêm sẽ được ghi nhận là nguồn "Tỉnh thêm" và bỏ qua bước rà soát của xã.</p>
        
        <form onSubmit={handleSubmit}>
          
          {/* PHẦN 1: THÔNG TIN CÁ NHÂN */}
          <div style={{marginBottom: '20px', border: '1px solid #eee', padding: '15px', borderRadius: '5px'}}>
            <h4>1. Thông tin cá nhân</h4>
            <div style={modalStyles.grid}>
              <div style={modalStyles.inputGroup}>
                <label>Xã/Phường (bắt buộc):</label>
                <select name="xa_id" value={xa_id} onChange={onChange} required>
                   <option value="">-- Chọn Xã --</option>
                   {xaPhuongList.map(xa => (
                      <option key={xa.id} value={xa.id}>{xa.ten_xa}</option>
                   ))}
                </select>
              </div>
              <div style={modalStyles.inputGroup}>
                <label>Họ tên (bắt buộc):</label>
                <input name="ho_ten" value={ho_ten} onChange={onChange} required />
              </div>
              
              {/* (*** SỬA ***) Thay 'ngay_sinh' bằng 'nam_sinh' */}
              <div style={modalStyles.inputGroup}>
                <label>Năm sinh (bắt buộc):</label>
                <input 
                  type="text" 
                  name="nam_sinh" 
                  value={nam_sinh} 
                  onChange={onChange} 
                  placeholder="YYYY (ví dụ: 1950)"
                  maxLength={4}
                  required 
                />
              </div>
              
              <div style={modalStyles.inputGroup}>
                <label>CCCD (bắt buộc, sẽ chỉ lưu 3 số cuối):</label>
                <input name="cccd" value={cccd} onChange={onChange} placeholder="Nhập đủ số CCCD" required />
              </div>
              <div style={{...modalStyles.inputGroup, gridColumn: 'span 2'}}>
                <label>Địa chỉ (bắt buộc):</label>
                <input name="dia_chi" value={dia_chi} onChange={onChange} required />
              </div>
            </div>
          </div>
          
          {/* PHẦN 2: THÔNG TIN LIỆT SĨ (Giữ nguyên) */}
          <div style={{marginBottom: '20px', border: '1px solid #eee', padding: '15px', borderRadius: '5px'}}>
            <h4>2. Thông tin Liệt sĩ liên quan</h4>
            <AddLietSiQuanHe
                xaId={xa_id} 
                moiQuanHeList={moiQuanHeList}
                setMoiQuanHeList={setMoiQuanHeList}
                setError={setError}
                clearError={clearError}
            />
          </div>
          
          {error && <p style={modalStyles.error}>{error}</p>}
          
          <div style={{textAlign: 'right', marginTop: '20px'}}>
            <button style={{...modalStyles.button, ...modalStyles.closeButton}} onClick={onClose} disabled={isSaving} type="button">
              Hủy
            </button>
            <button style={modalStyles.button} type="submit" disabled={isSaving}>
              {isSaving ? 'Đang lưu...' : 'Lưu và Thêm'}
            </button>
          </div>
        </form>
        
      </div>
    </div>
  );
}

export default AddThanNhanModalTinhAdmin;